module.exports = __webpack_public_path__ + "static/media/accepted.c1bd0dfc.svg";